import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberAccount } from '../../../../models/transactions/member-account';

@Component({
  selector: 'app-affected-accounts-card',
  templateUrl: './affected-accounts-card.component.html',
  styleUrls: ['./affected-accounts-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AffectedAccountsCardComponent {
  @Input() accounts: MemberAccount[] = [];
}
